export const COMMON_USE_KNOWLEDGE_TYPE = {
    document: 1,
    knowledgeBook: 2,
    repository: 3,
    excel: 4,
    group: 5,
    ppt: 6,
} as const;

export const COMMON_USE_KNOWLEDGE_EVENT_TYPE = {
    mention: 2,
    comment: 3,
    update: 5,
} as const;

// 星标Tag的类型
export const COMMON_USE_KNOWLEDGE_COLLECTION = {
    // 全部
    all: 0,
    // 知识库
    repository: 3,
    // 文档
    doc: 1,
    // 知识本
    knowledgebook: 2,
    // 表格
    table: 4,
    group: 5,
    // PPT
    ppt: 6,
    // 数据表
    datasheet: 7,
} as const;

// 选中tag
export const HOMEPAGE_TAG = {
    // 最近浏览
    view: 1,
    // 最近编辑
    edit: 2,
    // 全部
    all: 0,
    // 知识库
    repository: 3,
    // 文档
    doc: 1,
    // 协作目录
    knowledgebook: 2,
    // 表格
    table: 4,
    // 表格
    group: 5,
    // PPT
    ppt: 6,
    // 数据表
    datasheet: 7,
    // 分享
    share: 1,
    // @我
    at: 2,
    // 评论的
    comments: 3,
    // 创建的
    create: 4,
    // 关注的
    attention: 5,
    // 我的知识库
    myRepository: 6,
} as const;

// 下拉选项类型
export const SELECT_DROPMENU = {
    // 全部
    all: 0,
    // 知识库
    repository: 3,
    // 文档
    doc: 1,
    // 协作目录
    knowledgebook: 2,
    // 表格
    table: 4,
    // 表格
    group: 5,
    // PPT
    ppt: 6,
    // 数据表
    datasheet: 7,
    // 我的知识库
    myAdminRepository: 8,
    // 更新
    update: 9,
    // 评论
    comment: 10,
    // 转发
    forward: 11,
    // 权限变更
    permission: 12,
} as const;

// 关于我
export const SELECT_EMUMERATION = {
    0: 'all',
    9: 'update',
    10: 'comment',
    11: 'share',
    12: 'permission',
} as any;

// 关于我
export const COMMON_USE_KNOWLEDGE_INVOLVEDTYPE = {
    share: 1,
    at: 2,
    comments: 3,
    create: 4,
} as const;

export const IS_CLOSE_BATCH_ADD_LIST_STORAGE = 'isCloseBatchAddList';

// 首页-星标tag里的筛选
export const allGroupItemData = {
    labelName: '全部',
    id: '',
};
